export interface IFormatDocIdArgs {
    docId: string | null;
    withDocumentId?: boolean;
}

export const formatDocId = (
    {docId, withDocumentId}: IFormatDocIdArgs,
) => (withDocumentId ? docId || undefined : undefined);
